import HP from '../../assets/images/team-hp.png';

import { _ } from '../../utils/l10n';
import { HighlightText } from './HighlightText';

export const CompanyQuote = ({ children }: { children: React.ReactNode }) => (
  <div className="company-quote-container">
    {children}
    <div className="company-quote-bottom">
      <img className="company-quote-image" src={HP} alt="Hans-Peter Gier" />
      <div className="company-quote-bottom-text">
        <HighlightText>Hans-Peter Gier,</HighlightText>
        <span>{_('CEO and founder')}</span>
      </div>
    </div>
  </div>
);
